module.exports = __webpack_public_path__ + "img/growthAbility7.c801d124.png";